import React from "react";
import { createStep, TextInput, useForm } from "@/Components/formik-steps";
import Preview from "@/Components/steps/Preview";
import * as yup from "yup";
import { useError } from "@/Components/formik-steps/Error";

function CustomerStep() {
  const { values, setFieldValue } = useForm();

  const termsAgreementError = useError("terms_agreement");

  const dataAgreementError = useError("data_agreement");

  return (
    <div>
      <h1 className="text-[#070707] font-inter text-[40px] font-bold leading-[normal] tracking-[0.4px] mb-[36px]">
        Jouw gegevens
      </h1>

      <Preview />

      <h3 className="flex justify-left font-bold text-[24px] p-3">
        Vul je gegevens in
      </h3>

      <p className="text-[15px] font-Inter p-3">
        Vul hieronder jouw gegevens correct in. Zo kunnen we je op de hoogte
        houden van de afspraak voor jouw auto.
      </p>

      <div className="inline-flex w-full gap-5 mb-5 flex-col  sm:w-full">
        <TextInput name="first_name" placeholder="Voornaam" />
        <TextInput name="last_name" placeholder="Achternaam" />
      </div>

      <div className="inline-flex w-full gap-5  mb-5 flex-col sm:flex-row  sm:w-full">
        <TextInput name="postal_code" placeholder="Postcode" />
        <TextInput name="house_number" placeholder="Huisnummer" />
        <TextInput name="house_number_addition" placeholder="Toevoeging" />
      </div>

      <div className="inline-flex w-full gap-5 mb-5 flex-col sm:w-full">
        <TextInput name="phone" placeholder="Telefoonnummer" />
        <TextInput name="address" placeholder="Adres" />
        <TextInput name="email" placeholder="E-mailadres" />
      </div>

      <div className="inline-flex flex-col mt-10 gap-5 p-3">
        <div>
          <label className="inline-flex gap-2 sm:flex-row sm:gap-2">
            <input
              type="checkbox"
              value={values.terms_agreement}
              onClick={() =>
                setFieldValue("terms_agreement", !values.agreement)
              }
            />

            <p className="text-sm sm:mr-2 select-none">
              Ik ga akkoord met de algemene voorwaarden en privacy statement van
              All Mobiel Cars *
            </p>
          </label>
          <div>
            {termsAgreementError && (
              <div className="flex items-center ">
                <svg
                  className="shrink-0"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0.625C4.825 0.625 0.625 4.825 0.625 10C0.625 15.175 4.825 19.375 10 19.375C15.175 19.375 19.375 15.175 19.375 10C19.375 4.825 15.175 0.625 10 0.625ZM10 15.625C9.3125 15.625 8.75 15.0625 8.75 14.375C8.75 13.6875 9.3125 13.125 10 13.125C10.6875 13.125 11.25 13.6875 11.25 14.375C11.25 15.0625 10.6875 15.625 10 15.625ZM11.4313 5.93125L11.0125 10.9438C10.9688 11.4688 10.5312 11.875 10 11.875C9.46875 11.875 9.03125 11.4688 8.9875 10.9438L8.56875 5.93125C8.5 5.09375 9.15625 4.375 10 4.375C10.8 4.375 11.4375 5.025 11.4375 5.8125C11.4375 5.85 11.4375 5.89375 11.4313 5.93125Z"
                    fill="#FE4A49"
                  ></path>
                </svg>
                <div className="ml-1">
                  <p className="text-red-600   text-[13px]">
                    {termsAgreementError}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div>
          <label className="inline-flex gap-2 sm:flex-row sm:gap-2">
            <input
              type="checkbox"
              value={values.data_agreement}
              onClick={() => setFieldValue("data_agreement", !values.agreement)}
            />

            <p className="text-sm sm:mr-2 select-none">
              Ik heb mijn gegevens gecontroleerd en juist ingevuld. *
            </p>
          </label>
          <div>
            {dataAgreementError && (
              <div className="flex items-center">
                <div>
                  <svg
                    className="shrink-0"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0.625C4.825 0.625 0.625 4.825 0.625 10C0.625 15.175 4.825 19.375 10 19.375C15.175 19.375 19.375 15.175 19.375 10C19.375 4.825 15.175 0.625 10 0.625ZM10 15.625C9.3125 15.625 8.75 15.0625 8.75 14.375C8.75 13.6875 9.3125 13.125 10 13.125C10.6875 13.125 11.25 13.6875 11.25 14.375C11.25 15.0625 10.6875 15.625 10 15.625ZM11.4313 5.93125L11.0125 10.9438C10.9688 11.4688 10.5312 11.875 10 11.875C9.46875 11.875 9.03125 11.4688 8.9875 10.9438L8.56875 5.93125C8.5 5.09375 9.15625 4.375 10 4.375C10.8 4.375 11.4375 5.025 11.4375 5.8125C11.4375 5.85 11.4375 5.89375 11.4313 5.93125Z"
                      fill="#FE4A49"
                    ></path>
                  </svg>
                </div>

                <div className="ml-1">
                  <p className="text-red-600 text-[13px]">
                    {dataAgreementError}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default createStep({
  submit: true,
  component: <CustomerStep />,
  validation: {
    first_name: yup.string().required("Voornaam is verplicht"),
    last_name: yup.string().required("Achternaam is verplicht"),
    postal_code: yup.string().required("Postcode is verplicht"),
    house_number: yup.string().required("Huis nummer is verplicht"),
    house_number_addition: yup.string(),
    phone: yup.string().required("Telefoonnummer is verplicht"),
    address: yup.string().required("Adres is verplicht"),
    email: yup
      .string()
      .email("Ongeldig e-mailadres")
      .required("E-mailadres is verplicht"),
    terms_agreement: yup
      .boolean()
      .required("U moet akkoord gaan met de algemene voorwaarden")
      .oneOf(
        [true],
        "U moet akkoord gaan met de algemene voorwaarden en privacy statement"
      ),
    data_agreement: yup
      .boolean()
      .required("U moet akkoord gaan dat u alle velden correct heeft ingevuld")
      .oneOf([true], "U moet uw gegevens controleren en juist invullen"),
  },
});
